import { Router } from 'express';
import * as controller from './teams.controller';
import { authMiddleware } from '../../middleware/auth.middleware';
import { requirePermission } from '../../middleware/rbac.middleware';

const router = Router();
router.use(authMiddleware);

router.get('/', controller.list);
router.post('/', requirePermission('create_teams'), controller.create);
router.get('/:id', controller.getOne);
router.post('/:id/members', requirePermission('manage_team_members'), controller.addMember);
router.delete('/:id/members/:userId', requirePermission('manage_team_members'), controller.removeMember);
router.patch('/:id', requirePermission('edit_teams'), controller.update);
router.delete('/:id', requirePermission('delete_teams'), controller.remove);

export default router;
